import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { addTransactionFields } from "../../forms/transactionFields";
import { camelCaseToLabel, formatDate, validateField, validateSingleSectionFormData } from "../../utils/utils";
import DataFormField from "../common/DataFormField";
import Button from "../common/Button";


const AddTransactionFrom = () => {
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, type, files, value } = e.target;

    const newValue = type === "file" ? files[0] : value;

    setFormData((prev) => ({ ...prev, [name]: newValue }));
    setErrors((prev) => ({ ...prev, [name]: null }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;

    let fieldConfig;
    addTransactionFields.forEach((section) => {
      section.fields.forEach((field) => {
        if (field.inputProps.name === name) {
          fieldConfig = field;
        }
      });
    });

    if (fieldConfig?.inputProps?.validation) {
      const label = fieldConfig.label || camelCaseToLabel(name);
      const error = validateField(
        fieldConfig.inputProps.validation,
        value,
        label
      );
      setErrors((prev) => ({ ...prev, [name]: error }));
    }
  };

  const handleSubmit = async () => {
    const { errors, isValid } = validateSingleSectionFormData(
      addTransactionFields,
      formData
    );
    setErrors(errors);
    if (isValid) {
      const resp = await api.post("/admin/add-transaction", {
        ...formData,
      });

      if (resp.code === 200) {
        navigate("/admin/transactions", { state: { message : "Transaction added successfully" } });
      }
    }
  };

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {addTransactionFields?.map((section, sectionIndex) => (
          <React.Fragment key={sectionIndex}>
            {section.fields?.map((field, fieldIndex) => (
              <DataFormField
                key={`${sectionIndex}-${fieldIndex}`}
                labelClass="block text-sm font-medium mb-1"
                divClass={field?.divClass}
                label={field?.label}
                htmlFor={field?.htmlFor}
                error={errors[field.inputProps.name]}
                inputClass="w-full border rounded px-3 py-2 text-sm"
                inputProps={{
                  required: field.inputProps.required || "false",
                  type: field.inputProps.type || "text",
                  name: field.inputProps.name,
                  id: field.inputProps.name,
                  placeholder: field.inputProps.placeholder || "",
                  disabled: field.inputProps.disabled || false,
                  value:
                    field.inputProps.type === "date"
                      ? formatDate(formData[field.inputProps.name])
                      : formData[field.inputProps.name] || "",
                  onChange: handleChange,
                  onBlur: handleBlur,
                  options: field.inputProps.options || [],
                  maxLength: field.inputProps.maxLength || 255,
                  ...(field.inputProps.min ? { min: field.inputProps.min } : {}),
                  ...(field.inputProps.max ? { max: field.inputProps.max } : {}),
                  description: field.inputProps.description || "",
                  formatDocument: field.inputProps.formatDocument || null,
                }}
                formData={formData}
              />
            ))}
          </React.Fragment>
        ))}
      </div>

      <div className="flex justify-end mt-4">
        <Button className="bg-btn px-6 py-2 rounded" onClick={handleSubmit}>
          Submit
        </Button>
      </div>
    </>
  );
};

export default AddTransactionFrom;
